export const SprintActionTypes = {
    API_RESPONSE_SUCCESS: '@@sprint/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@sprint/API_RESPONSE_ERROR',
    GET_SPRINT_DATA: '@@sprint/GET_SPRINT_DATA',
    GET_SPRINT_BY_ID: '@@sprint/GET_SPRINT_BY_ID',
    ADD_SPRINT_DATA: '@@sprint/ADD_SPRINT_DATA',
    UPDATE_SPRINT_DATA: '@@sprint/UPDATE_SPRINT_DATA',
    DELETE_SPRINT_DATA: '@@sprint/DELETE_SPRINT_DATA',
    RESET_SPRINT_DATA: '@@sprint/RESET_SPRINT_DATA',
    GET_SPRINT_REPORT_DATA: '@@sprint/GET_SPRINT_REPORT_DATA',
};